import React from 'react';
import { Box, Typography, Button, Chip, Divider } from '@mui/material';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import BookmarkAddOutlinedIcon from '@mui/icons-material/BookmarkAddOutlined';

const S3_BASE_URL = 'https://qallix-academy.s3-ap-southeast-1.amazonaws.com/courses';

// Helper function to format duration
const formatDuration = (hours) => {
  if (hours < 1) {
    const minutes = Math.round(hours * 60);
    return `${minutes} Minute${minutes !== 1 ? 's' : ''}`;
  } else if (hours === Math.floor(hours)) {
    return `${hours} Hour${hours !== 1 ? 's' : ''}`;
  } else {
    const wholeHours = Math.floor(hours);
    const minutes = Math.round((hours - wholeHours) * 60);
    return `${wholeHours} Hour${wholeHours !== 1 ? 's' : ''} ${minutes} Minute${minutes !== 1 ? 's' : ''}`;
  }
};

const CourseOverview = ({
  courseId,
  title,
  level,
  lessons,
  duration,
  image,
  description,
  onStartCourse
}) => {
  const formattedDuration = formatDuration(duration);

  return (
    <Box>
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{ mb: 2, fontSize: '12px' }}>
        <Link
          underline="hover"
          color="inherit"
          href="/courses"
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          Courses
        </Link>
        <Typography color="text.primary" fontSize={12}>
          {title}
        </Typography>
      </Breadcrumbs>

      <Box sx={{
        display: 'flex',
        gap: 4,
        flexWrap: 'wrap',
        alignItems: 'flex-start',
        mb: 3
      }}>

        <Box sx={{ flex: 1, minWidth: '300px' }}>
          <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 1 }}>
            {title}
          </Typography>

          <Typography variant="body2" sx={{ mb: 2, mt: 2, fontSize: '13px', color: 'grey' }}>
            {level} | {lessons} Lesson{lessons !== 1 ? 's' : ''} | {formattedDuration}
          </Typography>

          <Box sx={{ display: 'flex' }}>
            <Button
              variant="contained"
              onClick={onStartCourse}
              sx={{
                textTransform: 'none',
                mr: '10px',
                backgroundColor: '#332872',
                color: 'white', // Ensure text is readable
                '&:hover': {
                  backgroundColor: '#2a2160', // Darker shade for hover
                }
              }}
            >
              Learn now
            </Button>
          </Box>
        </Box>

        <Box sx={{
          flex: '0 0 auto',
          width: { xs: '100%', sm: '400px' },
          textAlign: { xs: 'center', sm: 'right' }
        }}>
          <img
            src={image}
            alt={title}
            style={{
              maxWidth: '100%',
              borderRadius: '8px',
              objectFit: 'cover'
            }}
          />
        </Box>
      </Box>

      <Divider sx={{ my: 3 }} />

      <Typography variant="body1" style={{
        fontSize: '13px'
      }}>
        {description}
      </Typography>

    </Box>
  );
};

export default CourseOverview;